<template>
  <div class="table-responsive">
    <table class="table table-hover text-center" id="dataTable" width="100%"
      cellspacing="0">
      <thead>
        <tr>
          <th>Created_At</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" id="table_row" >
              <td colspan="16">
                <b-skeleton-wrapper >
                    <b-skeleton height="40px" ></b-skeleton>   
                    <b-skeleton height="40px"></b-skeleton>  
                    <b-skeleton height="40px"></b-skeleton>                                     
                </b-skeleton-wrapper> 
              </td>
            </tr>
        <terms-row v-show="!isLoader" v-for="term in terms" :term="term" :key="term.id"></terms-row>
      </tbody>
    </table>

    <paginate v-if="!isLoader" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
      :first-button-text="''" :last-button-text="''" :first-last-button="true"
      :container-class="'pagination pagination-sm mb-0 mt-2 mr-4 float-right'" :page-class="'page-item'" :prev-class="'page-item prev'"
      :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'"
      :next-link-class="'page-link'"></paginate>
  </div>
</template>

<script>
  import termsRow from './terms_row';
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      termsRow,VueSkeletonLoader
    },
    
    data: function () {
      return {
        isLoader: true,
      }
    },
    props: [
      'terms', 'totalPages', 'page','setSkeletonLoader'
    ],
    mounted: function () {
      this.showskLoader = this.setSkeletonLoader;
    },  
    computed: {
      currentPage: {
        get: function () {
          return this.page;
        },
        set: function () { }
      },
     showskLoader: {
        get:function(){
          return this.setSkeletonLoader
        },
        set: function (val) {
          this.isLoader = val;
          return val;
         },
      },
    },
    watch:{
      showskLoader: function (val) {
        this.isLoader = val;
        return val;
      }
     } ,
    methods: {
      setPage(page) {
        this.$emit('setPage', page);
      }
    }
  }
</script>